import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-27a900ed"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "cover-word-container"
};
var _hoisted_2 = {
  class: "cover-title particletext bubbles"
};
var _hoisted_3 = {
  class: "cover-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_arrow_down = _resolveComponent("arrow-down");

  var _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", {
    style: _normalizeStyle($setup.coverStyle),
    class: "cover"
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString($props.title), 1), _createElementVNode("p", _hoisted_3, _toDisplayString($props.content), 1), _createVNode(_component_el_icon, {
    size: "50px",
    class: "arrow-down",
    onClick: $setup.scrollToContent
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_arrow_down)];
    }),
    _: 1
  }, 8, ["onClick"])])], 4);
}